import React from "react";

const getAge = () => {
  const birth = new Date(1995, 4, 17); // May is month 4 (0-indexed)
  const today = new Date();
  let age = today.getFullYear() - birth.getFullYear();
  if (
    today.getMonth() < birth.getMonth() ||
    (today.getMonth() === birth.getMonth() && today.getDate() < birth.getDate())
  ) {
    age--;
  }
  return age;
};

const AboutAnimation = () => {
  return (
    <section className="d2-about" id="about" aria-labelledby="about-title">
      <div className="d2-container">
        <div className="about-layout">
          <div className="reveal">
            <div className="about-avatar" aria-label="Lakshay Parnami profile photo" style={{ background: "var(--bg-elevated)" }}>
              <img
                src={`${process.env.PUBLIC_URL}/img/about/about-me.jpg`}
                alt="Lakshay Parnami"
                style={{ width: "100%", height: "100%", objectFit: "cover", objectPosition: "top" }}
              />
              <div className="about-badge">
                <div className="about-badge-icon" aria-hidden="true">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <rect x="5" y="2" width="14" height="20" rx="2" />
                    <path d="M12 18h.01" />
                  </svg>
                </div>
                <div>
                  <div className="about-badge-text">SDE-4 Android @ Porter</div>
                  <div className="about-badge-sub">Jaipur, Rajasthan</div>
                </div>
              </div>
            </div>
          </div>

          <div>
            <span className="section-label reveal">About me</span>
            <h2 className="section-title reveal reveal-delay-1" id="about-title">Mobile Developer</h2>
            <div className="about-body reveal reveal-delay-2">
              <p>I'm an Mobile Developer with 7+ years of experience building scalable mobile applications. Currently SDE-4 Android at Porter, where I lead a team of engineers and architect systems handling 1.5K+ requests per second.</p>
              <p>I specialise in Kotlin, Jetpack Compose, and Clean Architecture — shipping production apps across fintech, media, gaming, and logistics with companies like YourStory, GoDutch, and CrimzonCode.</p>
              <table className="about-table" aria-label="Personal details">
                <tbody>
                  <tr><td>Name</td><td>Lakshay Parnami</td></tr>
                  <tr><td>Birthday</td><td>17th May 1995</td></tr>
                  <tr><td>Age</td><td>{getAge()}</td></tr>
                  <tr><td>Address</td><td>Jaipur, Rajasthan</td></tr>
                  <tr><td>Phone</td><td><a href="tel:+918107958922">+91 8107 958922</a></td></tr>
                  <tr><td>Email</td><td><a href="mailto:laksh.parnami@gmail.com">laksh.parnami@gmail.com</a></td></tr>
                  <tr>
                    <td>Freelance</td>
                    <td>
                      <span className="freelance-badge">
                        <span className="freelance-dot" />
                        Available
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
              <a href="#contactus" className="btn-primary">Get in touch</a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutAnimation;
